module.exports = __webpack_public_path__ + "static/media/camera-off.8e169d0e.svg";